import { UserVideoRequest, UserVideoResponse } from '../../../types/user'
import { useApiPostQuery } from '../useApi'

export const useUserVideo = (requestData: UserVideoRequest) => {
  return useApiPostQuery<UserVideoResponse>(
    '/user/video',
    ['userVideo', requestData],
    requestData,
    !!requestData.LEVEL_ID // LEVEL_ID가 있을 때만 활성화
  )
}
